<template>
  <lsa-account-alerts :alerts="snapshot.alerts" :checked-at="snapshot.checked_at" :stale="snapshot.stale" />
</template>
<script>
import axios from 'axios'
import LsaAccountAlerts from './LsaAccountAlerts.vue'
export default {
  components: { LsaAccountAlerts },
  props: { accountId: { type: [Number, String], required: true } },
  data: () => ({ snapshot: { alerts: [] }, generation: 0, timer: null }),
  watch: {
    accountId: { immediate: true, handler() { this.snapshot = { alerts: [] }; this.load() } }
  },
  mounted() { this.timer = setInterval(() => this.load(), 60000) },
  beforeDestroy() { clearInterval(this.timer); this.generation++ },
  methods: {
    async load() {
      const generation = ++this.generation
      try {
        const { data } = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/me/lsa-account-alerts`, {
          headers: { Authorization: 'Bearer ' + this.$store.state.auth.jwt }
        })
        if (generation === this.generation) this.snapshot = data
      } catch (error) {
        if (generation === this.generation) this.snapshot = { ...this.snapshot, stale: true }
      }
    }
  }
}
</script>
